import { useState, useEffect } from "react";
import chroma from "chroma-js";
import lockIt from "./functions/lockIt";
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
import "./App.scss";
import copyToClipboard from "./functions/copyToClipboard";
import getColorsFromHash from "./functions/getColorsFromHash"
import setTextColor from "./functions/setTextColor"
import updateColorsHash from "./functions/updateColorsHash"

function App() {
  const [initial, setInitial] = useState(true);
  useEffect(() => {
    console.log("from hash", getColorsFromHash());
    setRandomColors(initial);
    //setInitial(false)
    return () => {};
  }, []);
  
  document.addEventListener("keydown", (event) => {
    console.log("effect", event);
    if (event.code === "Space") {
      console.log("spacebar pressed");
      setRandomColors();
    }
  });
  // function generateRandomColor() {
  //   const hexCodes = "0123456789ABCDEF";
  //   let color = "";
  //   for (let i = 0; i < 6; i++) {
  //     color += hexCodes[Math.floor(Math.random() * hexCodes.length)];
  //   }
  //   return "#" + color;
  // }
  function setRandomColors(initial) {
    const cols = document.querySelectorAll(".col");
    console.log(`isInitial`, initial);
    const colors = initial ? getColorsFromHash() : [];
    cols.forEach((col, index) => {
      //let color = generateRandomColor()
      const isLocked = col.querySelector("i").classList.contains("fa-lock");
      console.log(`isLocked`, isLocked);
      if (isLocked) {
        console.log("locked", col.querySelector("h2").textContent);
        colors.push(col.querySelector("h2").textContent);
        return;
      }
      for (let i = 0; i < col.length; i++) {
        console.log(`col[i]`, col[i]);
      }
      // let color = chroma.random();
      const color = initial
        ? colors[index]
          ? colors[index]
          : chroma.random()
        : chroma.random();
      if (!initial) {
        colors.push(color);
      }
      //colors.push(color);
      col.style.background = color;
      let text = col.querySelector("h2");
      let button = col.querySelector("button");
      text.textContent = color;
      setTextColor(text, color);
      setTextColor(button, color);
    });
    console.log(`reached update colors`, colors);
    updateColorsHash(colors);
    if (colors.length < 1) {
      const cols = document.querySelectorAll(".col");
      let colors = [];
      cols.forEach((col, index) => {
        console.log("col", col);
        let color = col.querySelector("h2").textContent;
        colors.push(color);
      });
      updateColorsHash(colors);
    }
  }

  return (
    <div
      className="colors"
    >
      <div className="col">
        <h2 
        onClick={(e) => copyToClipboard(e.target.innerHTML)}
        
        >Text</h2>

        <button data-type="lock">
          <i className="fa-solid fa-lock-open" onClick={(e) => lockIt(e)}></i>
        </button>
      </div>
      <div className="col">
        <h2 onClick={(e) => copyToClipboard(e.target.innerHTML)}>Text</h2>
        <button>
          <i className="fa-solid fa-lock-open" onClick={(e) => lockIt(e)}></i>
        </button>
      </div>
      <div className="col">
        <h2 onClick={(e) => copyToClipboard(e.target.innerHTML)}>Text</h2>
        <button>
          <i className="fa-solid fa-lock-open" onClick={(e) => lockIt(e)}></i>
        </button>
      </div>
      <div className="col">
        <h2 onClick={(e) => copyToClipboard(e.target.innerHTML)}>Text</h2>
        <button>
          <i className="fa-solid fa-lock-open" onClick={(e) => lockIt(e)}></i>
        </button>
      </div>
      <div className="col">
        <h2 onClick={(e) => copyToClipboard(e.target.innerHTML)}>Text</h2>
        <button>
          <i className="fa-solid fa-lock-open" onClick={(e) => lockIt(e)}></i>
        </button>
      </div>
        <ToastContainer />
    </div>
  );
}

export default App;
